import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { LegalModal } from './ui/LegalModal';
import { PrivacyContent } from './PrivacyContent';
import { TermsContent } from './TermsContent';
export function SalesFooter() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="w-full px-4 py-16 bg-[#F5F2EB] mt-12" data-id="element-156">
        <div className="max-w-2xl mx-auto" data-id="element-157">
          <FadeIn data-id="element-158">
            <div className="prose-letter space-y-6 text-[#2D2A26] mb-12 text-center md:text-left" data-id="element-159">
              <p className="font-bold text-xl" data-id="element-160">
                If you're tired of negotiating with your own fear…
              </p>

              <p data-id="element-161">and you want a plan that feels calm, specific, and doable…</p>

              <div className="py-4" data-id="element-162">
                <p className="text-2xl font-serif italic text-[#7B9E6B]" data-id="element-163">
                  You don't need to "be brave."
                </p>
                <p className="text-2xl font-serif italic text-[#7B9E6B]" data-id="element-164">
                  You need a system that makes steady feel normal again.
                </p>
              </div>
            </div>

            <div className="flex justify-center mb-16" data-id="element-165">
              <Button showArrow className="px-10" onClick={() => document.getElementById('purchase')?.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })} data-id="element-166">
                Get Started Today - $6.39
              </Button>
            </div>

            <div className="border-t border-[#2D2A26]/10 pt-8 text-center" data-id="element-167">
              <p className="text-sm text-[#2D2A26]/60 leading-relaxed max-w-xl mx-auto mb-8" data-id="element-168">
                <strong data-id="element-169">Disclaimer:</strong> The information provided in this
                guide is for educational purposes only and is not intended as a
                substitute for professional medical advice, diagnosis, or
                treatment. Always seek the advice of your physician or other
                qualified health provider with any questions you may have
                regarding a medical condition. If you experience dizziness,
                pain, or shortness of breath, stop immediately and consult a
                healthcare professional.
              </p>

              <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm text-[#2D2A26]/50" data-id="element-170">
                <p data-id="element-171">
                  © {new Date().getFullYear()} No-Fall Confidence. All rights
                  reserved.
                </p>
                <div className="flex items-center gap-4" data-id="element-172">
                  <button onClick={() => setActiveModal('privacy')} className="hover:text-[#7B9E6B] transition-colors underline decoration-transparent hover:decoration-[#7B9E6B] underline-offset-4" data-id="element-173">
                    Privacy Policy
                  </button>
                  <span className="w-1 h-1 bg-[#2D2A26]/30 rounded-full" aria-hidden="true" data-id="element-174" />
                  <button onClick={() => setActiveModal('terms')} className="hover:text-[#7B9E6B] transition-colors underline decoration-transparent hover:decoration-[#7B9E6B] underline-offset-4" data-id="element-175">
                    Terms of Service
                  </button>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </footer>

      {/* Legal Modals */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Privacy Policy" data-id="element-176">
        <PrivacyContent data-id="element-177" />
      </LegalModal>

      <LegalModal isOpen={activeModal === 'terms'} onClose={closeModal} title="Terms of Service" data-id="element-178">
        <TermsContent data-id="element-179" />
      </LegalModal>
    </>;
}